// Event-driven URL syncing for Jelly navigation.
// Historically we polled the address bar every 100ms. Firefox throttles timers heavily in background tabs,
// so we schedule checks on pushState/replaceState/popstate/focus/visibilitychange and keep polling as fallback.

if (!Jelly.Navigation)
	Jelly.Navigation = {};

Jelly.Navigation.Path_Check_Pending = false;

Jelly.Navigation.Schedule_Check = function(Reason)
{
	// Debounce: coalesce multiple URL changes into one Watch_Address_Bar call.
	if (Jelly.Navigation.Path_Check_Pending)
		return;

	Jelly.Navigation.Path_Check_Pending = true;

	window.setTimeout(function() {
		Jelly.Navigation.Path_Check_Pending = false;

		// Only run if the watcher exists (defensive for early init).
		if (typeof Jelly.Watch_Address_Bar == "function")
			Jelly.Watch_Address_Bar();
	}, 0);
};

Jelly.Navigation.History_Patched = false;

Jelly.Navigation.Patch_History = function()
{
	if (Jelly.Navigation.History_Patched)
		return;

	Jelly.Navigation.History_Patched = true;

	if (window.history && window.history.pushState)
	{
		var Original_Push_State = window.history.pushState;
		window.history.pushState = function()
		{
			Original_Push_State.apply(window.history, arguments);
			Jelly.Navigation.Schedule_Check("pushState");
		};
	}

	if (window.history && window.history.replaceState)
	{
		var Original_Replace_State = window.history.replaceState;
		window.history.replaceState = function()
		{
			Original_Replace_State.apply(window.history, arguments);
			Jelly.Navigation.Schedule_Check("replaceState");
		};
	}
};


